import { IconAction } from '@nimmsta/ng-commons-lib';
import { Observable, of } from 'rxjs';
import { Configuration, State } from '../../models/configuration';

export class ClearDownloadAction extends IconAction<Configuration> {
  constructor(isActive?: (id: string) => boolean) {
    super('download', 'download', false, isActive);
  }

  override isEnabled(configuration: Configuration): Observable<boolean> {
    return of(configuration.state === State.READY);
  }
}
